import styled from 'styled-components';
import { colors, Icon } from '@dexma/ui-components';

type WrapperProps = {
    fontSize: number;
};

export const StyledErrorIcon = styled(Icon)`
    color: ${colors.gray400};
`;

export const StyledOuterWrapper = styled.div<WrapperProps>`
    font-size: ${({ fontSize }) => fontSize}px;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
`;

export const StyledBar = styled.div`
    width: calc(100% - 16px);
    border-radius: 4px;
    margin: 8px 0 0 0;
    color: ${colors.gray400};
    border-top: 4px solid ${colors.gray400};
`;

export const StyledErrorTitle = styled.h1`
    color: ${colors.gray400};
    font-size: 1.2em;
    text-align: center;
    font-weight: bold;
`;

export const StyledErrorMessage = styled.p`
    color: ${colors.gray300};
    font-size: 1.2em;
    text-align: center;
    text-align: center;
    background-color: white;
    padding: 0 1em;
    border-radius: 8px;
`;

export const StyledErrorContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    align-items: center;
`;
